import { BadgeType } from 'interfaces/dealer-opinions.interface';

/* eslint-disable max-len */

export default function getOpineoBadgeDescription(badgeType: BadgeType): string[] {
    if (badgeType === 'BASIC') {
        return ['firma współpracuje z Opineo i korzysta z usług Serwisu dla Słuchających'];
    }

    if (badgeType === 'SILVER') {
        return [
            'firma ma odznakę podstawową i utrzymuje jej kryteria,',
            'uzyskała w serwisie Opineo średnią ocen co najmniej 4.5 biorąc pod uwagę ostatnie 30 dni,',
            'korzysta z manualnego systemu lub skryptu usługi Ankietowania,',
            'otrzymała co najmniej 10 Wiarygodnych Opinii w ciągu ostatnich 30 dni, które poprzedziło zaproszenie do wystawienia opinii zrealizowane manualnym systemem lub skryptem usługi Ankietowania,',
            'opinie są wiarygodne pod względem technicznym'
        ];
    }

    if (badgeType === 'GOLD') {
        return [
            'firma ma odznakę srebrną i utrzymuje jej kryteria,',
            'korzysta z usługi Ankietowania za pomocą skryptu automatycznego,',
            'otrzymała co najmniej 10 Wiarygodnych Opinii w ciągu ostatnich 30 dni, a ponad 80% otrzymanych opinii poprzedziło zaproszenie zrealizowane skryptem usługi Ankietowania,',
            'współpracuje z Opineo i korzysta z usług Serwisu dla Słuchających co najmniej 90 dni'
        ];
    }

    if (badgeType === 'PLATINUM') {
        return [
            'firma ma odznakę złotą i utrzymuje jej kryteria,',
            'uzyskała w serwisie Opineo średnią ocen co najmniej 4.8 biorąc pod uwagę ostatnie 30 dni,',
            'otrzymała mniej niż 5 % opinii w kategorii "negatywne" w ciągu ostatnich 30 dni,',
            'posiada aktywny Certyfikat Opineo'
        ];
    }

    return [];
}
